import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateMarkAnimationSettingParams {
  user: string;
  enabled: boolean;
}

export class UpdateMarkAnimationSettingRequest extends Request<IUpdateMarkAnimationSettingParams, IResult> {
  constructor(params: IUpdateMarkAnimationSettingParams) {
    super('updateMarkAnimationEnabledSetting', params);
  }
}
